export let BASE_URL: any = '/aperio/api';
//http://iptpdk607.ibs.net:17124
